var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"append-icon":"mdi-magnify","label":_vm.label,"color":"primary","clearable":"","outlined":"","dense":"","autocomplete":"off"},model:{value:(_vm.search.value),callback:function ($$v) {_vm.$set(_vm.search, "value", $$v)},expression:"search.value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }